import React from "react";
import "./styles.scss";
import PropTypes from "prop-types";

const ContainerReponse = ({ children }) => {
	return (
		<div id="containerResponse">
			{children}
		</div>
	);
};

ContainerReponse.propTypes = {
	children: PropTypes.node,
};

export default ContainerReponse;